import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'child-cell',
  template: `
  <span>
    <i class="fa fa-plus-square edit text-primary" (click)="invokeParentMethod()" title="Add Feedback"></i>
  </span>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class FeedbackButtonRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.params.data['action'] = 'add';
    this.params.context.componentParent.methodFromParent(
        this.params.data
    );
  }

  refresh(): boolean {
    return false;
  }
}